import {useTranslation} from "react-i18next";
import {Table} from "react-bootstrap";

const TableWarnings = (props) => {
    const [t] = useTranslation("tables");

    return (
        <div className="col-12 mt-3">
            <h3 className="text-warning text-center">{t("labels.warnings")}</h3>
            <Table striped bordered responsive>
                <thead>
                    <tr>
                        <th style={{width: "60px"}}>Linea</th>
                        <th style={{width: "220px"}}>Activo</th>
                        <th>Mensaje</th>
                    </tr>
                </thead>
                <tbody className="text-warning">
                    {props.items.map((item, index) => (
                        <tr key={index} data-idx={index}>
                            <td>{item.line}</td>
                            <td>{item.active}</td>
                            <td>{item.message}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default TableWarnings;
